export const GENERAL_SETTINGS_ROUTE = '/dashboard/general-settings';
export const TMC_MENU_OPTION = 'clothing-settings';
export const DEAL_PAYROLL_LEGACY_ROUTE = '/dashboard/admin/deal-payroll-catalog';
export const ROUTE_PATH_INDEX = 0;
export const MENU_MISSING_INDEX = -1;
export const MENU_ROUTE_SEPARATOR = '/';
export const STANDARDS_MENU_OPTIONS = ['m-stands', 'm-stands-sho', 'all-stnds'];
export const NAVBAR_ROLES = {
  head: 'ROLE_HEAD', admin: 'ROLE_ADMIN', user: 'ROLE_USER', specializationAdmin: 'ROLE_ADMIN_SPECIALIZATION'
};
export const WORKFLOW_MENU_ROUTES = [
  {path: '/dashboard/admin/clothing', option: TMC_MENU_OPTION},
  {path: '/dashboard/offboarding/assignments', option: 'clothing-settings'},
  {path: '/dashboard/offboarding', option: 'offboarding'}
];
export const QUERY_MENU_OPTIONS: {[path: string]: string} = {
  '/dashboard': 'home',
  '/dashboard/home': 'home',
  '/dashboard/report': 'm-report',
  '/dashboard/standards': 'm-stands',
  '/dashboard/admin/all-standards-head-only': 'm-stands-sho',
  '/dashboard/admin/all-standards-head': 'all-stnds',
  '/dashboard/specializations': 'spec-list',
  '/dashboard/specializations-list': 'spec-list',
  '/dashboard/learning': 'learning',
  '/dashboard/my-suggestion-lists': 'my-sl',
  '/dashboard/admin/ai-statistics': 'ai-statistics',
  '/dashboard/general-settings': 'general-settings',
  '/dashboard/admin/deal-payroll-catalog': 'general-settings',
  '/dashboard/admin/clothing': 'clothing-settings',
  '/dashboard/admin/clothing/assignments': 'clothing-settings',
  '/dashboard/admin/clothing/responsibilities': 'clothing-settings',
  '/dashboard/admin/clothing/report': 'clothing-settings'
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/navbar/navbar.constants.ts